export type Station = {
	Enabled: boolean;
	Id: string;
	Name: string;
	Description: string;
	Owner: string;
	Latitude: number;
	Longitude: number;
	Elevation: number | null;
	SupportedDataTypes: DataTypes;
	HasWindData: boolean;
	HasAirTemperatur: boolean;
	HasWaveData: boolean;
	HasCurrentData: boolean;
	HasStillImages: boolean;
	HasLiveFeed: boolean;
	Measurements: Measurement[]
	Cameras: Camera[]
}
export enum DataTypes {
	None = 0, // None
	Wind = 1 << 0, // Wind
	AirTemperature = 1 << 1, // Airtemperature
	SeaTemperature = 1 << 2,
	Image = 1 << 3,
	Waves = 1 << 4,
	Current = 1 << 5
}

export enum DataSampleType {
	NONE,
	WIND_SPEED,
	WIND_DIRECTION,
	WIND_GUST_SPEED,
	WIND_GUST_DIRECTION,
	CURRENT_SPEED,
	CURRENT_DIRECTION,
	SEATEMP,
	AIRTEMP,
	STILLIMAGE,
	LIVEFEED
}

export enum DataSampleUnit {
	UNKNOWN,
	METERS_PER_SECOND,
	MILLIMETERS_PER_SECOND,
	KNOTS,
	DEGREES,
	METERS,
	CELSIUS
}

export type DataSample = { Source: string, StationId: string, MvId: string, IsInstant: boolean, Timestamp: Date, Unit: DataSampleUnit, Type: DataSampleType, Value: number, Valid: boolean };

export type Measurement = { Id: string, IsInstValue: boolean, IsHistValue: boolean, SampleType: DataSampleType, Unit: DataSampleUnit }
export type Camera = { Enabled: boolean, Id: string, Name: string, IsLive: boolean; StreamUrl: string }

export type BadgeKind = "current" | "wave" | "camera" | "wind" | "temp";
export type StationStatus = 'fresh' | 'stale' | 'offline';